/*
 * Creator discount codes from the ad URL (?code=olivia15 → OLIVIA15), shared by the creator
 * video hero (collection pages, pb-creator-video-hero.js) and PDP v4 (pdp-v4.js).
 *
 * - match(codes, search): the entry whose `param` equals ?code= (case-insensitive), or null.
 *   An entry is { param, code, percentage }.
 * - apply(entry, codes): puts the code on the headless cart with PBCart.applyDiscountCode()
 *   and resolves true once it is on the cart, false when it is refused or fails.
 *   The other codes of the same list are taken off first: the creator codes are order
 *   discounts that combine with each other in Shopify, so OLIVIA10 + OLIVIA15 would stack.
 * - price(cents, percentage): what an order-level percentage code leaves of an amount.
 *
 * Docs: .cursor/references/creator-video-hero.md
 */
(function () {
  if (window.PBCreatorCode) return;

  const same = (a, b) => String(a || '').toLowerCase() === String(b || '').toLowerCase();

  // Shopify rounds the discount amount down: measured in the cart, Oct 2026 (3585 at 15% → 3048).
  function price(cents, percentage) {
    return cents - Math.floor((cents * percentage) / 100);
  }

  function match(codes, search) {
    let wanted = '';
    try {
      wanted = (new URLSearchParams(search).get('code') || '').trim().toLowerCase();
    } catch (_) {}
    return (wanted && codes.find((entry) => entry && entry.param === wanted)) || null;
  }

  async function waitForPBCart(maxMs = 12000) {
    const start = Date.now();
    while (Date.now() - start < maxMs) {
      if (typeof window.PBCart?.applyDiscountCode === 'function') return true;
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    return false;
  }

  // A code that does not exist is dropped from the cart. One that exists comes back
  // applicable:false on an empty cart (it counts once there are lines), so only with lines
  // does applicable:false mean refused.
  const onCart = (cart, code) =>
    (cart?.discountCodes || []).some(
      (item) => same(item.code, code) && (item.applicable !== false || !cart.totalQuantity),
    );

  async function apply(entry, codes) {
    // The theme editor previews the page only; it must not touch a real cart.
    if (window.Shopify?.designMode) return true;
    if (!(await waitForPBCart())) {
      window.PBDebug?.warn?.('[PB creator code] PBCart not available, code not applied', entry.code);
      return false;
    }

    try {
      const cart = await window.PBCart.current();
      // PDP v4 calls this on every page view while the layer is on: no cart call when it is already there.
      if (onCart(cart, entry.code)) return true;
      const others = (cart?.discountCodes || [])
        .map((item) => item.code)
        .filter((code) => !same(code, entry.code) && codes.some((c) => same(c.code, code)));
      for (const code of others) await window.PBCart.removeDiscountCode(code);

      const updated = await window.PBCart.applyDiscountCode(entry.code);
      const landed = onCart(updated, entry.code);
      window.PBDebug?.log?.('[PB creator code]', entry.code, landed ? 'applied' : 'refused');
      return landed;
    } catch (error) {
      console.error('[PB creator code] code not applied', entry.code, error);
      return false;
    }
  }

  window.PBCreatorCode = { match, apply, price };
})();
